import { gql } from '@apollo/client';

export const UPSERT_TEMPLATE = gql`
  mutation upsertTemplate($input: UpsertTemplateInput!) {
    template: upsertTemplate(input: $input) {
      id
    }
  }
`;
